module.exports = __webpack_public_path__ + "media/assets/gifs/listed-publish-329e0ccc35ec2fbca3f749a117def37a.gif";